module.exports = __webpack_public_path__ + "static/media/logo-blanco.8aef8a41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-blanco.svg
// module id = 220
// module chunks = 0